import React, { useEffect, useState } from 'react';
import { api } from '../../services/api';

// Selector de "Solicitante" con búsqueda sobre el catálogo real de usuarios
// (admin_users), en vez de un input de texto libre. Guarda el ID del
// usuario (requesterId) y muestra el nombre — ver
// docs/ANALISIS_OC_SIN_REQUISICION.md sección 1.
export default function RequesterPicker({ requesterId, requesterName, onSelect, placeholder = 'Buscar solicitante por nombre o correo...' }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const q = String(query || '').trim();
    if (q.length < 2) {
      setOptions([]);
      setLoading(false);
      return;
    }
    let alive = true;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const res = await api.accounting.purchaseRequests.listRequesters({ q, limit: 20 });
        const rows = Array.isArray(res?.data) ? res.data : [];
        if (alive) setOptions(rows);
      } catch (_) {
        if (alive) setOptions([]);
      } finally {
        if (alive) setLoading(false);
      }
    }, 250);
    return () => { alive = false; clearTimeout(t); };
  }, [query]);

  const pick = (user) => {
    onSelect({ id: String(user.id), name: user.name || '', email: user.email || '' });
    setQuery('');
    setOpen(false);
  };

  return (
    <div className="relative">
      {requesterId ? (
        <div className="flex items-center justify-between w-full border rounded-xl px-3 py-2 bg-gray-50">
          <span className="text-sm text-gray-800">{requesterName || `Usuario #${requesterId}`}</span>
          <button
            type="button"
            onClick={() => onSelect({ id: '', name: '', email: '' })}
            className="text-xs text-blue-600 hover:text-blue-800 ml-2"
          >
            Cambiar
          </button>
        </div>
      ) : (
        <>
          <input
            value={query}
            onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
            onFocus={() => setOpen(true)}
            className="w-full border rounded-xl px-3 py-2 bg-gray-50"
            placeholder={placeholder}
          />
          {open && query.trim().length >= 2 && (
            <div className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-xl shadow overflow-hidden">
              <div className="max-h-56 overflow-y-auto">
                {loading ? (
                  <div className="px-3 py-2 text-sm text-gray-600">Buscando...</div>
                ) : options.length === 0 ? (
                  <div className="px-3 py-2 text-sm text-gray-600">Sin resultados</div>
                ) : (
                  options.map((u) => (
                    <button
                      key={u.id}
                      type="button"
                      className="w-full text-left px-3 py-2 hover:bg-gray-50"
                      onClick={() => pick(u)}
                    >
                      <div className="text-sm text-gray-800">{u.name || 'Sin nombre'}</div>
                      <div className="text-xs text-gray-500">{u.email || ''}</div>
                    </button>
                  ))
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
